import { type EMRInfo, type EMRTypeID } from './documents/_EMR.ts'
import { GAHTFHTConsent_ID, GAHTMHTConsent_ID } from './documents/GAHTConsent.ts'

const gahtConsentTypes = new Set<EMRTypeID>([GAHTFHTConsent_ID, GAHTMHTConsent_ID])

function getMyCareConsent({myRecords}: {
	myRecords: EMRInfo[]
}) {
	return myRecords.filter(r => gahtConsentTypes.has(r.type)).toReversed()[0]
}

export function getMyCareStartedOn({myRecords}: {
	myRecords: EMRInfo[]
}) {
	return getMyCareConsent({myRecords})?.timestamp ?? null
}

export function getMyCareTherapy({myRecords}: {
	myRecords: EMRInfo[]
}) {
	const myConsent = getMyCareConsent({myRecords})
	if (!myConsent) return null
	return myConsent.type === GAHTFHTConsent_ID ? 'FHT' : myConsent.type === GAHTMHTConsent_ID ? 'MHT' : undefined
}
